export const SERVICE = 'SNACKBAR'
